import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '@application/config';
import { TPersonModule, TPersonProductValidity } from '../entities/system-modules.model';

@Injectable({ providedIn: 'root' })
export class SystemModulesService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(APP_CONFIG).apiUrl.subscription_service;

  public getPersonModules(): Observable<TPersonModule[]> {
    // `/Person/products` (no `/module`) returns Module-category products AND
    // Service-category ones (SMS / e-mail dispatch, etc.), so each instant-message
    // channel can be gated by its own product. `/Person/products/module` omits Services.
    return this.http.get<TPersonModule[]>(`${this.apiUrl}/Person/products`, {
      withCredentials: true
    });
  }

  /**
   * Ate quando cada produto esta disponivel. Endpoint irmao do de cima, na mesma base — aquele diz
   * o que esta ativo, este diz ate quando. Nenhum dos dois responde as duas perguntas.
   *
   * Sem parametro: o servidor deriva a pessoa do Bearer. O nome do endpoint ainda diz `ByPerson`,
   * mas essa pessoa ja nao viaja no pedido — mandar um `PersonId` seria pedir ao servidor que
   * confiasse no cliente para dizer de quem sao os prazos.
   */
  public getProductsValidity(): Observable<TPersonProductValidity[]> {
    return this.http.get<TPersonProductValidity[]>(
      `${this.apiUrl}/Subscription/GetProductsByPerson`,
      { withCredentials: true }
    );
  }
}

